import React from "react";
import { AlertTriangle } from "lucide-react";
import i18n from "../i18n";

// Global safety net. Without this, any uncaught render error in the production
// build unmounts the whole React tree and leaves a fully BLANK white screen
// (the onboarding "pantalla en blanco" reported in production). This catches it
// and shows a friendly EN/ES message with a way to continue.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Surface the real cause in the browser console / monitoring, never hide it.
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    const t = (k) => i18n.t(k);
    return (
      <div
        className="flex min-h-screen items-center justify-center px-4 py-12"
        data-testid="error-boundary"
      >
        <div className="w-full max-w-md rounded-xl border border-amber-200 bg-amber-50 p-6 text-center">
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 text-amber-700">
            <AlertTriangle className="h-6 w-6" />
          </div>
          <h1 className="font-heading text-lg font-bold text-amber-900" data-testid="error-boundary-title">
            {t("errorBoundary.title")}
          </h1>
          <p className="mt-2 text-sm text-amber-800" data-testid="error-boundary-message">
            {t("errorBoundary.message")}
          </p>
          <div className="mt-5 flex flex-col gap-2 sm:flex-row sm:justify-center">
            <button
              type="button"
              onClick={() => { window.location.href = "/auth"; }}
              className="rounded-full bg-brand px-5 py-2 text-sm font-semibold text-white hover:bg-brand/90"
              data-testid="error-boundary-login"
            >
              {t("errorBoundary.login")}
            </button>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="rounded-full border border-amber-300 px-5 py-2 text-sm font-semibold text-amber-900 hover:bg-amber-100"
              data-testid="error-boundary-reload"
            >
              {t("errorBoundary.retry")}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
